import { render, staticRenderFns } from "./BedSizeForm.vue?vue&type=template&id=6f61296a&scoped=true"
import script from "./BedSizeForm.vue?vue&type=script&lang=js"
export * from "./BedSizeForm.vue?vue&type=script&lang=js"
import style0 from "./BedSizeForm.vue?vue&type=style&index=0&id=6f61296a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f61296a",
  null
  
)

export default component.exports